import { useFormik } from 'formik';
import * as yup from 'yup';

const validationSchema = yup.object().shape({
  url: yup
    .string()
    .required('Vui lòng nhập đường dẫn(URL)')
    .url('Vui lòng nhập đúng định dạng đường dẫn(URL): https://example.com'),
  description: yup.string().required('Vui lòng nhập mô tả'),
});
const initialValues = {
  url: '',
  description: '',
};

const useReportForm = ({ handleSubmit }) => {
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  return {
    formik,
  };
};

export default useReportForm;
